var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsTimelineDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 4.16797C13.5202 4.16797 4.16602 13.5221 4.16602 25.0013C4.16602 36.4805 13.5202 45.8346 24.9994 45.8346C36.4785 45.8346 45.8327 36.4805 45.8327 25.0013C45.8327 13.5221 36.4785 4.16797 24.9994 4.16797ZM34.9577 20.2096L23.1452 32.0221C22.8535 32.3138 22.4577 32.4805 22.041 32.4805C21.6244 32.4805 21.2285 32.3138 20.9369 32.0221L15.041 26.1263C14.4368 25.5221 14.4368 24.5221 15.041 23.918C15.6452 23.3138 16.6452 23.3138 17.2493 23.918L22.041 28.7096L32.7494 18.0013C33.3535 17.3971 34.3535 17.3971 34.9577 18.0013C35.5619 18.6055 35.5619 19.5846 34.9577 20.2096Z",
    fill: "#39B54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsTimelineDone);
export default __webpack_public_path__ + "static/media/ads-timeline-done.5a46c1f04a4eec7a9c56e427d0f0be88.svg";
export { ForwardRef as ReactComponent };